import Constant from '@/constant'
import EventBus from '@/eventBus'

const setTotalJoinedPresentationAction = ({ commit }, payload) => {
  commit('setTotalJoinedPresentation', payload)
}

const setTotalAnsweredSlideAction = ({ commit }, payload) => {
  commit('setTotalAnsweredSlide', payload)
}

const clearEveryoneAnsweredPresentationAction = ({ commit }) => {
  commit('clearEveryoneAnsweredPresentation')
}
const clearEveryoneAnsweredSlideAction = ({ commit }) => {
  commit('clearEveryoneAnsweredSlide')
}
const checkEveryoneHasAnsweredAction = async ({ state }, payload) => {
  const countJoined = state.totalJoinedPresentation[payload.presentationId]
  const countAnswered = state.totalAnsweredSlide[payload.slideId]
  const isQuizRunning = state.slideActive.type === 'pickAnswer' && state.slideActive.quizStatus === Constant.QuizStatuses.QUESTION_SCREEN
  if (countJoined && countAnswered && countJoined === countAnswered &&
      isQuizRunning && countJoined >= state.userOnline) {
    EventBus.$emit('everyone-voted')
  }
}

const resetCountingEveryoneHasAnswered = async ({ dispatch, state, commit }) => {
  const countingPayload = {
    keys: [
      {
        bucket: `presentation-${state.presentation.id}`,
        key: `everyone-answered-joined-${state.presentation.version}`,
      },
      {
        bucket: `presentation-${state.presentation.id}`,
        key: `everyone-answered-answer-${state.slideActive.id}-${state.slideActive.version}`,
      },
    ],
  }
  await dispatch('resetCounting', countingPayload)
  commit('clearEveryoneAnsweredPresentation')
  commit('clearEveryoneAnsweredSlide')
  return null
}

export default {
  setTotalJoinedPresentationAction,
  setTotalAnsweredSlideAction,
  checkEveryoneHasAnsweredAction,
  clearEveryoneAnsweredPresentationAction,
  clearEveryoneAnsweredSlideAction,
  resetCountingEveryoneHasAnswered,
}
